import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteAnaliseMercadoStatusPretendidoModule } from '../../status-pretendido';
import { ClienteAnaliseMercadoStatusProjetadoModule } from '../../status-projetado';
import { ClienteAnaliseMercadoLancamentoModule } from '../../lancamento';
import { ClienteTypeaheadSharedModule } from '../../../pessoa/cliente/typeahead';
import { GrupoClassificacaoSelectModule } from '../../../grupo-classificacao/select';
import { GrupoClassificacaoClassificavelFormModule } from '../../../grupo-classificacao/classificavel/form';

import { ClienteAnaliseMercadoClassificacaoLancamentoComponent } from './cliente-analise-mercado-classificacao-lancamento.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoStatusPretendidoModule,
        ClienteAnaliseMercadoStatusProjetadoModule,
        ClienteAnaliseMercadoLancamentoModule,
        ClienteTypeaheadSharedModule,
        GrupoClassificacaoSelectModule,
        GrupoClassificacaoClassificavelFormModule
    ],
    declarations: [
        ClienteAnaliseMercadoClassificacaoLancamentoComponent
    ],
    exports: [
        ClienteAnaliseMercadoClassificacaoLancamentoComponent
    ]
})
export class ClienteAnaliseMercadoClassificacaoLancamentoModule { }
